import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, UrlSegment } from '@angular/router';

export function homeUrl(url: UrlSegment[]) {
  return url.length > 0 && url[url.length - 1].path === 'home' ? ({ consumed: url }) : null;
}

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    matcher: homeUrl,
    loadChildren: () => import('./modules/pension-outlook/pension-outlook.module').then(m => m.PensionOutlookModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        preloadingStrategy: PreloadAllModules
      }
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
